import Marquee from "react-fast-marquee";

export default function BrandMarquee() {
  const items = ["Premium Mobile Detailing", "Ottawa", "Reverence", "We Come To You", "Showroom Fresh"];
  return (
    <div data-testid="brand-marquee" className="border-y border-brand-silver/30 bg-brand-offwhite py-6">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-serif text-2xl font-semibold tracking-tight text-brand-charcoal/80 sm:text-3xl">
              {t}
            </span>
            <span className="text-brand-red">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
